<template>
<div>
     <v-card v-if="lightTheme" light>
        <v-card-title v-if="props.title">
            {{ props.title }}
        </v-card-title>
        <v-card-text>
            <v-textarea class="ma-0 area__statement mb-5" :label="label" auto-grow v-model.trim="item" type="text" required :hide-details="true" :color="color" :prefix="prefix" :theme="theme"></v-textarea>
        </v-card-text>
    </v-card>
     <v-card v-else light>
        <v-card-title v-if="props.title">
            {{ props.title }}
        </v-card-title>
        <v-card-text>
            <v-textarea class="ma-0 area__statement mb-5" :label="label" auto-grow v-model.trim="item" type="text" required :hide-details="true" :color="color" :prefix="prefix" :theme="theme"></v-textarea>
        </v-card-text>
    </v-card>
    </div>

</template>

<script>
// @ is an alias to /src
export default {
    name: "TextArea",
    props: {
        label: String,
        title: String,
        tag: String,
        color: {
            type: String,
            default: 'amber'
        },
        value: String,
        prefix: {
            type: String,
            default: ''
        },
        props: {
            type: Object,
            default: null,
        },
        theme: {
          type: String,
            default: 'light',
        },

    },
    data() {
        return {
            item: this.value,
        };
    },
    watch: {
        item: {
            deep: true,
            handler(val) {
                this.$emit("input", val);
            },
        },
        value(val) {
            this.item = val;
        },
    },
    computed: {
      lightTheme() {
        return (this.theme == 'light') ? true : false;
      }
    }
};
</script>
